import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { ic_info } from 'react-icons-kit/md/ic_info';
import { chevronUp } from 'react-icons-kit/fa/chevronUp';
import { chevronDown } from 'react-icons-kit/fa/chevronDown';
import { Icon } from 'react-icons-kit';
import ReactTooltip from 'react-tooltip';

import Button from 'components/Button/Button';
import Results from 'components/Results/Results';
import Warning from 'components/Warning/Warning';
import CheckBox from 'components/CheckBox/CheckBox';
import CustomModal from 'components/CustomModal/CustomModal';
import { removeUploadedLayers, getExtentByCoordinates, extentIntersectsBbox } from 'utils/Visor';

import RequestService from 'services/RequestService';

import './Filters.css';

declare var CONFIGURATIONS;

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year_from: undefined,
      year_to: undefined,
      flightType: undefined,
      query: undefined,
      type: undefined,
      color: undefined,
      inside_view: false,
      results: [],
      open: false,
      modalOption: undefined,
      actionSelected: undefined,
      hidden: false,
      searched: false,
      flightTypes: [],
      allFlights: [],
    };
  }

  componentWillMount() {
    const _this = this;
    _this.props.block();
    Promise.all([
      RequestService.getRequest(CONFIGURATIONS.ckan_url + '/package_search?fq=(vocab_publicado:True%20AND%20vocab_tipo_datos:Vuelo*)&rows=1000'),
      RequestService.getRequest(CONFIGURATIONS.ckan_url + '/vocabulary_list'),
    ]).then((responses) => {
      let results = [];
      const flights = responses[0].result.results;
      responses[1].result.filter((r) => {
        return r.name === 'tipo vuelos';
      }).forEach((r) => {
        results = results.concat(r.tags);
      });

      _this.setState({ flightTypes: results, flightType: 'all', allFlights: flights }, () => {
        _this.props.unblock();
        _this.props.setAllFlights(flights);
      });
    }).catch((err) => {
      _this.props.unblock();
      _this.handleOpen('error-loading');
    });
  }

  onChangeFormField = (name, evt) => {
    let newState = this.state;
    let value = undefined;
    if (name === 'inside_view') {
      value = !this.state.inside_view;
    } else {
      value = evt.target.value;
    }

    newState[name] = value;
    this.setState(newState);
  }

  search = () => {
    const { flightType, query, year_from, year_to, type, color, inside_view, allFlights } = this.state;
    //TODO
    const _this = this;
    this.props.block();
    let results = [].concat(allFlights);
    if (flightType !== 'all') {
      results = results.filter((f) => {
        const type = f.extras.filter((e) => e.key === 'Tipología vuelo')[0].value;
        return flightType === type;
      });
    }

    if (type !== 'all' && type !== undefined) {
      results = results.filter((f) => {
        const typeAux = f.extras.filter((e) => e.key === 'Tipo vuelo')[0].value;
        return type === typeAux;
      });
    }

    if (color !== 'all' && color !== undefined) {
      results = results.filter((f) => {
        const colorAux = f.extras.filter((e) => e.key === 'Color')[0].value;
        return color === colorAux;
      });
    }

    if (inside_view) {
      results = results.filter((f) => {
        const extent = getExtentByCoordinates(JSON.parse(f.extras.filter((e) => e.key === 'spatial')[0].value));
        return extentIntersectsBbox(extent);
      });
    }

    if (year_from !== undefined && year_to !== undefined) {
      results = results.filter((f) => {
        const date = parseInt(f.extras.filter((e) => e.key === 'Fecha')[0].value, 10);
        return date >= year_from && date <= year_to;
      });
    }

    if (query !== undefined && query.length > 0) {
      const q = query.toLowerCase();
      results = results.filter((f) => {
        const notes = f.notes.toLowerCase();
        const title = f.title.toLowerCase();
        const type = f.extras.filter((e) => e.key === 'Tipología vuelo')[0].value.toLowerCase();
        const flightType = f.extras.filter((e) => e.key === 'Tipo vuelo')[0].value.toLowerCase();
        return notes.indexOf(q) > -1 || title.indexOf(q) > -1 || type.indexOf(q) > -1 || flightType.indexOf(q) > -1;
      });
    }

    this.setState({ searched: true, results: results }, () => {
      _this.props.setSearched(true);
      _this.props.setFlights(results);
      _this.props.unblock();
    });
  }

  clean = () => {
    removeUploadedLayers();
    const _this = this;
    this.props.block();
    this.setState({
      year_from: undefined,
      year_to: undefined,
      flightType: 'all',
      type: 'all',
      color: 'all',
      query: '',
      results: [],
      actionSelected: undefined,
      searched: false,
    }, () => {
      _this.props.setSearched(false);
      _this.props.setFlights([]);
      _this.props.setSelectedFlight(undefined);
      _this.props.unblock();
      document.getElementById('queryText').value = '';
    });
  }

  handleOpen = (modalOption) => {
    this.setState({ open: true, modalOption: modalOption });
  }

  handleClose = () => {
    this.setState({ open: false, modalOption: undefined });
  }

  toogleHidden = () => {
    const inv = !this.state.hidden;
    this.setState({ hidden: inv }, () => {
      const elem = document.querySelector('div.listContainer > div.table.row > div');
      if (inv && elem !== null) {
        elem.style.maxHeight = 'calc(100vh - 550px)';
      } else if (elem !== null) {
        elem.style.maxHeight = 'calc(100vh - 750px)';
      }
    });
  }

  render() {
    const { t } = this.props;
    const { flightType, query, year_from, year_to, type, color, results, open, modalOption, hidden, searched, inside_view, flightTypes } = this.state;
    const optionsFlightTypes = [<option value={'all'} key="allTypes">{t('filters.all_typologies')}</option>];
    const optionsFrom = [<option value='default' key='fromDefault'>{t('filters.select')}</option>];
    const optionsTo = [<option value='default' key='toDefault'>{t('filters.select')}</option>];
    const years = [];
    for (let i = CONFIGURATIONS.first_year_seach; i <= new Date().getFullYear(); i++) {
      years.push(i);
    }

    years.forEach((y) => {
      optionsFrom.push(<option key={'from' + y} value={y}>{y}</option>);
      if (year_from !== undefined && y >= year_from) {
        optionsTo.push(<option key={'to' + y} value={y}>{y}</option>);
      } else if (year_from === undefined) {
        optionsTo.push(<option key={'to' + y} value={y}>{y}</option>);
      }
    });

    flightTypes.forEach((ft) => {
      optionsFlightTypes.push(<option key={ft.id} value={ft.display_name}>{ft.display_name}</option>);
    });

    return (
      <div className='filtersContainer'>
        <div className='filtersTitleContainer row'>
          <div className='title'>{t('filters.search_flights')}</div>
          <div className='collapse-icon' onClick={this.toogleHidden}><Icon size={'1.2rem'} icon={hidden ? chevronDown : chevronUp}/></div>
        </div>
        { !hidden && !searched ?
          <div>
            <div className='filtersFormContainer row'>
              <table>
                <tbody>
                  <tr>
                    <td className='attribute-selector-field-title'>{t('filters.text')}</td>
                    <td className='attribute-selector-field-value'>
                      <input type='text' id='queryText' name='queryText' defaultValue={query} onChange={this.onChangeFormField.bind(null, 'query')} />
                    </td>
                  </tr>
                  <tr>
                    <td className='attribute-selector-field-title'>{t('filters.flight_type')}</td>
                    <td className='attribute-selector-field-value'>
                      <select id='selectType' defaultValue={type} onChange={this.onChangeFormField.bind(null, 'type')}>
                        <option value={'all'}>{t('filters.all_types')}</option>
                        <option value={'Analógico'}>{t('filters.analogic')}</option>
                        <option value={'Digital'}>{t('filters.digital')}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className='attribute-selector-field-title'>{t('filters.typology')}</td>
                    <td className='attribute-selector-field-value'>
                      <select id='selectFlightType' defaultValue={flightType} onChange={this.onChangeFormField.bind(null, 'flightType')}>
                        {optionsFlightTypes}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className='attribute-selector-field-title'>{t('filters.colour')}</td>
                    <td className='attribute-selector-field-value'>
                      <select id='selectColor' defaultValue={color} onChange={this.onChangeFormField.bind(null, 'color')}>
                        <option value={'all'}>{t('filters.all_colors')}</option>
                        <option value={'B/N'}>{t('B/N')}</option>
                        <option value={'RGB'}>{t('RGB')}</option>
                        <option value={'RGBI'}>{t('RGBI')}</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className='attribute-selector-field-title'>
                      {t('filters.date')}
                      <React.Fragment>
                        <span data-tip data-for={'infoTooltip'} className='tooltipInfo'>
                          <Icon size={'18px'} icon={ic_info}/>
                        </span>
                        <ReactTooltip className={''} id={'infoTooltip'} effect='solid' place='right'>
                          <span>{t('filters.select_range')}</span>
                        </ReactTooltip>
                      </React.Fragment>
                    </td>
                    <td className='attribute-selector-field-value' style={{ display: 'flex', justifyContent: 'center' }}>
                      <select id='flightYearFrom' defaultValue={year_from || 'default'} onChange={this.onChangeFormField.bind(null, 'year_from')} style={{ minWidth: '80px', marginRight: '10px' }}>
                        {optionsFrom}
                      </select>
                      <span className='flightYearSeparator'>{t('filters.and')}</span>
                      <select id='flightYearTo' defaultValue={year_to || 'default'} onChange={this.onChangeFormField.bind(null, 'year_to')} style={{ minWidth: '80px', marginLeft: '10px' }}>
                        {optionsTo}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className='attribute-selector-field-title'>{t('filters.inside_view')}</td>
                    <td className='attribute-selector-field-value'>
                      <CheckBox onClick={this.onChangeFormField.bind(null, 'inside_view')} isSelected={inside_view} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='filtersButtonContainer row'>
              <Button text={t('filters.search')} active={true} onClick={this.search} />
              { results.length > 0 ?
                <Button text={t('filters.clean')} active={true} onClick={this.clean} />
              : null }
            </div>
            <CustomModal open={open} onClose={this.handleClose} title={undefined}>
              { modalOption === 'empty' ?
                <Warning>
                  <p style={{ width: '160px', textAlign: 'center' }}>{t('filters.please')}</p>
                </Warning>
              : modalOption === 'wrong-format' ?
                <Warning>
                  <p style={{ width: '160px', textAlign: 'center' }}>{t('filters.check')}</p>
                </Warning>
              : modalOption === 'error-loading' ?
                <Warning>
                  <p style={{ width: '160px', textAlign: 'center' }}>{t('filters.load_error')}</p>
                </Warning>
              : null }
            </CustomModal>
          </div>
        : !hidden && searched ?
          <React.Fragment>
            <Results results={this.state.results} block={this.props.block} unblock={this.props.unblock}
              setSelectedFlight={this.props.setSelectedFlight} flightLayer={this.props.flightLayer} />
            <div className='filtersButtonContainer row'>
              <Button text={t('filters.back')} active={true} onClick={this.clean} />
            </div>
          </React.Fragment>
        : null }
      </div>
    );
  }
}

export default translate()(Filters);
